import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactInfoSection from "./ContactInfoSection";
import ContactForm from "../../components/ContactFrom/ContactForm";

const ContactPage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact Us" pagesub="Contact" />
            <ContactInfoSection />

            <section className="contact pb-120">
              <div className="container">
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 0,
                  borderRadius: 16,
                  overflow: "hidden",
                  border: "1px solid rgba(15,32,64,0.08)",
                  boxShadow: "0 8px 40px rgba(15,32,64,0.08)",
                }}>

                  {/* Left: Contact Form */}
                  <div style={{ background: "#ffffff", padding: "48px 44px" }}>
                    <div style={{ marginBottom: 32 }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#00c896", letterSpacing: "0.1em", textTransform: "uppercase" }}>Get Started</span>
                      <h3 style={{ color: "#0f2040", fontWeight: 700, fontSize: 28, marginTop: 8, marginBottom: 8 }}>
                        Talk to our team
                      </h3>
                      <p style={{ color: "rgba(15,32,64,0.55)", fontSize: 15, lineHeight: 1.6 }}>
                        Tell us about your use case and we'll get back to you within one business day.
                      </p>
                    </div>
                    <ContactForm />
                  </div>

                  {/* Right: Map */}
                  <div style={{ minHeight: 500 }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.521937491822!2d106.79599147460938!3d-6.243732399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3a1f2c73e17%3A0x5aea4d01ee69d39b!2sMenara%20Sentraya!5e0!3m2!1sen!2sid!4v1700000000000!5m2!1sen!2sid"
                      loading="lazy"
                      title="TrustEngine Office - Menara Sentraya Jakarta"
                      referrerPolicy="no-referrer-when-downgrade"
                      style={{ width: "100%", height: "100%", border: 0, minHeight: 500 }}
                      allowFullScreen
                    />
                  </div>

                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;
